import React from 'react';
import { Inbox, InboxInitialFilters } from './index';

export default (): React.ReactElement => {
    const filters: InboxInitialFilters = {
        unread: true,
        receivedFromTo: {
            dateFrom: new Date('August 23, 2022'),
        },
    };
    return <Inbox initialFilters={filters} />;
};


export const src = "import React from 'react';\nimport { Inbox, InboxInitialFilters } from './index';\n\nexport default (): React.ReactElement => {\n    const filters: InboxInitialFilters = {\n        unread: true,\n        receivedFromTo: {\n            dateFrom: new Date('August 23, 2022'),\n        },\n    };\n    return <Inbox initialFilters={filters} />;\n};\n";